import styled from 'styled-components';
import Typography from '@klv/atoms/typography';

export const StyledPricingModalContent = styled.div`
  display: flex;
  column-gap: 4.8rem;
  flex-direction: column;
  row-gap: 4.9rem;

  ${({ theme }) => theme.screenSize.s1024.mediaQuery} {
    flex-direction: row;
  }
`;

export const TextColumn = styled.div`
  width: 100%;

  p:not(:last-child) {
    margin: 0 0 2.4rem;
  }
`;

export const MediaColumn = styled.div`
  display: none;
  width: 100%;

  ${({ theme }) => `
    ${theme.screenSize.s1024.mediaQuery} {
      display: block;
    }
  `}
`;

export const Image = styled.img``;

export const StyledHeadline = styled(Typography)`
  margin: 0 0 2.4rem 0;
`;

export const Copy = styled(Typography)`
  margin-bottom: 3.6rem;
`;

export const CreditBreakdown = styled.ul`
  display: grid;
  grid-template-columns: repeat(2, max-content);
  grid-template-rows: repeat(2, max-content);
  column-gap: 2.4rem;
  row-gap: 2.4rem;
  list-style: none;
  margin: 0;
  padding: 0;

  ${({ theme }) => `
    ${theme.fonts.sohne.regular}
    font-size: 1.6rem;
    font-weight: 500;
    line-height: 1.5;
  `}
`;

export const Region = styled.li`
  width: 100%;
`;

export const RegionCredits = styled.ul`
  font-weight: 400;
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const CreditEntry = styled.li``;
